export interface VideoMapSafeFrame {
  readonly left: number;
  readonly right: number;
  readonly top: number;
  readonly bottom: number;
}

export interface VideoOverlayBox {
  readonly left: number;
  readonly top: number;
  readonly width: number;
  readonly height: number;
}

export interface VideoOverlayLayout {
  readonly title: VideoOverlayBox;
  readonly information: VideoOverlayBox;
  readonly brand: VideoOverlayBox;
}

export function videoOverlayLayout(width: number, height: number): VideoOverlayLayout {
  const scale = Math.min(width, height) / 720;
  const side = 36 * scale;
  const story = height / width >= 1.45;
  const titleWidth = Math.min(width - side * 2, (story ? 500 : 460) * scale);
  const titleHeight = (story ? 100 : 96) * scale;
  const informationWidth = Math.min(width - side * 2, (story ? 620 : 560) * scale);
  const informationHeight = (story ? 216 : 180) * scale;
  const informationTop = story ? height * 0.5 : height * 0.48;
  const brandWidth = Math.min(width - side * 2, (story ? 340 : 320) * scale);
  const brandHeight = (story ? 72 : 64) * scale;

  return {
    title: {
      left: (width - titleWidth) / 2,
      top: story ? Math.max(height * 0.105, 92 * scale) : 38 * scale,
      width: titleWidth,
      height: titleHeight,
    },
    information: {
      left: (width - informationWidth) / 2,
      top: informationTop,
      width: informationWidth,
      height: informationHeight,
    },
    brand: {
      left: (width - brandWidth) / 2,
      top: informationTop + informationHeight + 12 * scale,
      width: brandWidth,
      height: brandHeight,
    },
  };
}

/**
 * Keeps map details clear of the fixed title and story cards in both output ratios.
 * Values use the final video coordinate space rather than the rendered map scale.
 */
export function videoMapSafeFrame(width: number, height: number): VideoMapSafeFrame {
  const scale = Math.min(width, height) / 720;
  const overlays = videoOverlayLayout(width, height);
  const story = height / width >= 1.45;
  return {
    left: width * 0.14,
    right: width * 0.86,
    top: overlays.title.top + overlays.title.height + 16 * scale,
    bottom: story ? height * 0.82 : height * 0.84,
  };
}
